import React from 'react';
import './Companies.css';
import recruitOne from '../../../assets/Recruiter/recruiterOne.png'
import recruitTwo from '../../../assets/Recruiter/recruiterTwo.png'
import recruitFour from '../../../assets/Recruiter/recruiterFour.png'
import recruitNine from '../../../assets/Recruiter/recruiterNine.png'

function Companies() {
  return (
    <div className='companies-outer'>
      <div className="companies-inner">
        <h2 className="header-text">
          Companies where our students are placed
        </h2>
        <div className="companies">
          <div className="company">
            <img src={recruitOne} alt="royal carribean prince" />
          </div>
          <div className="company">
            <img src={recruitTwo} alt="princess cruises" />
          </div>
          <div className="company">
          <img src={recruitNine} alt="costa cruise" />
          </div>
          <div className="company">
          <img src={recruitFour} alt="disney cruise line" />
          </div>
        </div>
      </div>

    </div>
  )
}

export default Companies
